import { createContext, useContext } from 'react';

/**
 * Typed session-context factory: each app instantiates it with its own
 * session shape and wraps the Provider in its thin SessionProvider.
 */
export function createSessionContext<T>() {
    const SessionContext = createContext<T | null>(null);

    function useSession(): T {
        const ctx = useContext(SessionContext);
        if (ctx === null) {
            throw new Error('useSession must be used within a SessionProvider');
        }
        return ctx;
    }

    return { Provider: SessionContext.Provider, useSession };
}
